import { get } from "lodash";
import { SolicitorCompletionStatusEnum } from "../../enum/solicitor-completion-status.enum";
import { SubmitDocuments } from "../CooSubmission.class";
import { InstrumentDto } from "./Instrument.class";

export class SolicitorCompletionDetail {
  application_uuid: string;
  status: SolicitorCompletionStatusEnum;
  can_view: boolean;
  can_edit: boolean;
  completion?: SolicitorCompletionResponse;
  lodgement?: SolicitorLodgementResponse;

  constructor(initial?: SolicitorCompletionDetail) {
    this.application_uuid = get(initial, "application_uuid", "NO_ACTION");
    this.status = get(initial, "status", "NO_ACTION");
    this.can_view = get(initial, "can_view", false);
    this.can_edit = get(initial, "can_edit", false);

    if (initial?.completion) {
      this.completion = new SolicitorCompletionResponse(initial.completion);
    }

    if (initial?.lodgement) {
      this.lodgement = new SolicitorLodgementResponse(initial?.lodgement);
    }
  }
}

export class SolicitorCompletionResponse {
  actual_completion_date: string;
  submitted_by: string;
  submitted_at: string;
  documents: SubmitDocuments[];

  constructor(initial?: SolicitorCompletionResponse) {
    this.actual_completion_date = get(initial, "actual_completion_date", "");
    this.submitted_by = get(initial, "submitted_by", "");
    this.submitted_at = get(initial, "submitted_at", "");
    this.documents = get(initial, "documents", []).map((document) => new SubmitDocuments(document));
  }
}

export class SolicitorLodgementResponse {
  lodgement_date: string;
  instruments: InstrumentDto[];
  submitted_by: string;
  submitted_at: string;
  documents: SubmitDocuments[];

  constructor(initial?: SolicitorLodgementResponse) {
    this.lodgement_date = get(initial, "lodgement_date", "");
    this.instruments = get(initial, "instruments", []).map(
      ({ instrument_type, registration_date, number, uuid }) => new InstrumentDto(instrument_type, number, registration_date, uuid)
    );
    this.submitted_by = get(initial, "submitted_by", "");
    this.submitted_at = get(initial, "submitted_at", "");
    this.documents = get(initial, "documents", []).map((document) => new SubmitDocuments(document));
  }
}

export class SolicitorCompletionRequest {
  application_uuid: string;
  actual_completion_date: string;
  submitted_by: string;
  documents: SubmitDocuments[];

  constructor(initial?: any) {
    this.application_uuid = get(initial, "application_uuid", "");
    this.actual_completion_date = get(initial, "actual_completion_date", "");
    this.submitted_by = get(initial, "submitted_by", "");
    this.documents = get(initial, "documents", []);
  }

  getPayload() {
    return { ...this };
  }
}

export class SolicitorLodgementRequest {
  application_uuid: string;
  documents: SubmitDocuments[];
  instruments: InstrumentDto[];
  lodgement_date: string;
  submitted_by: string;

  constructor(initial: Partial<SolicitorLodgementRequest>) {
    this.application_uuid = get(initial, "application_uuid", "");
    this.documents = get(initial, "documents", []);
    this.instruments = get(initial, "instruments", []);
    this.lodgement_date = get(initial, "lodgement_date", "");
    this.submitted_by = get(initial, "submitted_by", "");
  }

  getPayload() {
    return { ...this };
  }
}
